import _ from 'underscore'
import EditUserViewTemplate from '../templates/edit-user.tpl'
import Backbone from 'backbone'
import Request from '../helpers/request'
import ClassModel from '../models/class'
import Translate from '../helpers/translate-data-attributes'
import Alert from '../helpers/alert'
import messages from '../messages'
import ClassOptionView from './class-option'
import PromoCodeView from './promo-code'

const EditUserView = Backbone.View.extend({
    tagName: 'div',
    id: 'form-view',
    schoolView: null,
    edit: true,
    purchased: false,
    update: false, // for the profile view
    inputSettings: 'autocomplete=off autocorrect=off autocapitalize=off spellcheck=false',
    events: {
        'click .close': 'close',
        'click .submit': 'submitUser',
        'click .reset': 'updatePassword',
        'click .delete': 'deleteUser',
        'click .reject': 'rejectFromSchool',
        'click .promo-code': 'promoCode',
        'click .password': 'showPasswordFields',
        'click .join': 'joinSchool',
        'click .logout': 'logout',
    },
    initialize(options) {
        if (options && options.schoolView) {
            this.schoolView = options.schoolView
        }

        this.template = _.template(EditUserViewTemplate)
        this.purchased = this.model.get('purchased').purchased()
    },
    render() {
        const data = this.model.toJSON()
        data.purchased = this.model.get('purchased').decorate()
        this.$el.html(this.template(data))

        if (this.model.get('type').get('name') === 'student') {
            Request({
                url: '/api/school/class',
                method: 'GET',
                data: {
                    limit: 500,
                    sort: 'nameLowercase',
                },
            })
                .then((response) => this.getClasses(response))
        }

        return this
    },
    getClasses(response) {
        const classId = this.model.get('class').get('id')

        _.each(response.docs, (classItem) => {
            const classModel = new ClassModel({
                id: classItem._id,
                name: classItem.name,
                selected: classId === classItem._id,
            })
            const classView = new ClassOptionView({model: classModel})
            this.$('#class').append(classView.render().el)
        })
    },
    showPasswordFields() {
        this.$el.find('.hidden').removeClass('hidden')
        this.$el.find('.password').addClass('hidden')
    },
    joinSchool() {
        Backbone.history.navigate('join-school', {trigger: true})
    },
    close() {
        if (this.schoolView) {
            this.schoolView.render()
        } else {
            Backbone.history.navigate('', {trigger: true, replace: true})
            Backbone.history.navigate('school', {trigger: true, replace: true})
        }
    },
    submitUser() {
        const role = this.$el.find('#role').val()
        const email = this.$el.find('#email').val()
        const class_id = this.$el.find('#class').val()

        const attributes = {
            firstname: this.$el.find('#firstname').val(),
            lastname: this.$el.find('#lastname').val(),
            username: this.$el.find('#username').val(),
        }

        // if there adding a student or teacher we need the password
        if (this.edit === false) {
            attributes.password = this.$el.find('#password').val()
        }

        // add email
        // if there editing or adding a teacher/individual the email gets added
        if (['teacher', 'individual'].indexOf(this.model.get('type').get('name')) !== -1) {
            attributes.email = email
        }

        // add the type
        if (this.edit === false && this.update === false) {
            attributes.type = this.model.get('type').get('name')
        }

        // add the role
        if (this.update === false && this.model.get('type').get('name') === 'teacher') {
            // editing or adding a teacher
            attributes.role = role
        }

        // add the school pin if adding student or teacher
        if (this.edit === false && this.update === false &&
            ['teacher', 'student'].indexOf(this.model.get('type').get('name')) !== -1) {
            attributes.schoolPin = this.model.get('school').get('pin')
        }

        // add class id
        if (class_id) {
            attributes.classId = class_id
        }

        new Promise((resolve, reject) => {
            // check for any blank items
            for (const item in attributes) {
                if (attributes[item].trim() === '') {
                    reject(Translate(item))
                }
            }
            resolve()
        })
            .then(() => {
                // update or create user
                if (this.edit) {
                    // update
                    if (this.update || this.model.get('id') === 0) {
                        // submitted on the profile so use the update me api
                        return this.model.update(attributes)
                    } else {
                        // submitted in the school section so use the school api's
                        if (this.model.get('type').get('name') === 'teacher') {
                            return this.model.updateTeacher(attributes)
                        } else {
                            return this.model.updateStudent(attributes)
                        }
                    }
                } else {
                    // create
                    return this.model.create(attributes)
                }
            })
            .then(() => this.close())
            .catch(Alert)
    },
    updatePassword() {
        const password = this.$el.find('#password').val()
        const confirmPassword = this.$el.find('#confirm-password').val()
        const attributes = {}

        // add password
        // edit - if there editing a user and entered a password it gets added
        // add - if they are adding a user the password is always added
        if (password || this.edit === false) {
            attributes.password = password
        }

        // add password if there is one
        // this only appears on the profile view
        if (confirmPassword) {
            attributes.confirm_password = confirmPassword
        }

        // check if the passwords match
        if (this.update && attributes.password !== attributes.confirm_password) {
            Alert(messages.MSG_PASSWORDS_DONT_MATCH)
        } else {
            this.model.updatePassword(attributes.password).then(() => this.close())
        }
    },
    promoCode() {
        const promoCodeView = new PromoCodeView({model: this.model})
        this.$('#form-wrapper').html(promoCodeView.render().el)
    },
    rejectFromSchool() {
        this.model.removeSchool().then(() => this.close())
    },
    deleteUser() {
        // default this to the delete user message
        let message = messages.MSG_CONFIRM_DELETE_USER

        // if submitted on the profile use the profile messages
        if (this.update || this.model.get('id') === 0) {
            if (this.model.get('role').get('name') === 'super admin') {
                // if super admin warn them about what they are going to do
                message = messages.MSG_CONFIRM_DELETE_SUPER_ADMIN
            } else {
                message = messages.MSG_CONFIRM_DELETE_ME
            }
        }

        // display the warning
        const conf = confirm(message)

        // if they agree delete the user
        if (conf) {
            this.model.delete().then(() => {
                if (this.update || this.model.get('id') === 0) {
                    if (this.model.get('role').get('name') === 'super admin') {
                        // notify the super-admin that the account deletion request has been sent
                        return Alert(messages.MSG_SUCCESS_DELETE_SUPER_ADMIN)
                    } else {
                        // if run on the logged in user log them out and say deletion success
                        return this.model.logout().catch(() => Alert(messages.MSG_SUCCESS_DELETE_ME))
                    }
                } else {
                    // if deleting a user close the edit user window
                    return this.close()
                }
            })
        }
    },
    logout() {
        this.model.logout()
    }
})

export default EditUserView